import s from './TitleBlock.module.css';
import { TitleBlockProps } from '@/types/model';
import { Button } from '@/components';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

const TitleBlock = ({ cta, title }: TitleBlockProps) => {
  const t = useTranslations('common');
  const handleClick = () => {
    window.location.href = cta.action!;
  };

  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.3 } }}
      className={s.container}>
      <h2>{title}</h2>
      {cta && <Button label={t('seeMore')} onClick={handleClick} />}
    </motion.div>
  );
};

export default TitleBlock;
